export const percentage = (percent, obtained, total) => {
  let result = 0;
  if (
    typeof percent === "number" &&
    typeof obtained === "number" &&
    typeof total === "number"
  ) {
    result = (obtained * percent) / total;
  }
  return parseInt(result);
};
